(function() {
  'use strict';

  if (window.__farMetaMatchBootstrap) return;
  window.__farMetaMatchBootstrap = true;

  var FBP_DAYS = 730;
  var FBC_DAYS = 90;
  var FBP_PATTERN = /^fb\.\d+\.\d{10,13}\.[A-Za-z0-9_-]+$/;
  var FBCLID_PATTERN = /^[A-Za-z0-9_-]{10,500}$/;

  function hasPrivacyOptOut() {
    return navigator.globalPrivacyControl === true ||
      navigator.doNotTrack === '1' ||
      navigator.msDoNotTrack === '1' ||
      window.doNotTrack === '1';
  }

  function safeDecode(value) {
    try {
      return decodeURIComponent(value);
    } catch (_) {
      return value;
    }
  }

  function getCookie(name) {
    var escapedName = name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escapedName + '=([^;]*)'));
    return match ? safeDecode(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + expires +
      '; path=/; SameSite=Lax; Secure';
  }

  function clearCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax; Secure';
  }

  function randomComponent() {
    try {
      var values = new Uint32Array(2);
      crypto.getRandomValues(values);
      return String(values[0]) + String(values[1]);
    } catch (_) {
      return String(Math.floor(Math.random() * 2147483647)) +
        String(Math.floor(Math.random() * 2147483647));
    }
  }

  function getQueryParam(name) {
    try {
      return new URLSearchParams(window.location.search).get(name);
    } catch (_) {
      var match = window.location.search.match(new RegExp('[?&]' + name + '=([^&]+)'));
      return match ? safeDecode(match[1].replace(/\+/g, ' ')) : null;
    }
  }

  if (hasPrivacyOptOut()) return;

  var fbp = getCookie('_fbp');
  if (!fbp || !FBP_PATTERN.test(fbp)) {
    writeCookie('_fbp', 'fb.1.' + Date.now() + '.' + randomComponent(), FBP_DAYS);
  }

  var fbclid = getQueryParam('fbclid');
  if (fbclid && FBCLID_PATTERN.test(fbclid)) {
    writeCookie('_fbc', 'fb.1.' + Date.now() + '.' + fbclid, FBC_DAYS);
  } else if (getCookie('_fbc') === '') {
    clearCookie('_fbc');
  }
})();
